import { render, staticRenderFns } from "./EditPayPassword.vue?vue&type=template&id=aade9080&scoped=true&"
import script from "./EditPayPassword.vue?vue&type=script&lang=js&"
export * from "./EditPayPassword.vue?vue&type=script&lang=js&"
import style0 from "./EditPayPassword.vue?vue&type=style&index=0&id=aade9080&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aade9080",
  null
  
)

export default component.exports